import { createWaveformData } from './createWaveformData';

type JsonResponse = {
  audioId: number;
  state: string;
  waveform: WaveformData;
};

type WaveformData = {
  version: number;
  channels: number;
  sampleRate: number;
  samplesPerPixel: number;
  bits: number;
  length: number;
  data: number[];
};

type Parameters = {
  webAudioId: string;
};

export async function fetchWaveformData({
  webAudioId,
}: Parameters): Promise<JsonResponse> {
  try {
    const response = await fetch(
      `/api/proxy/v3/audios/webAudioId:${webAudioId}/waveform`,
      {
        method: 'GET',
        credentials: 'same-origin',
      }
    );
    if (response.ok) {
      const result = await response.json();
      if (result.state === 'not_processed') {
        // no waveform data, make post request to generate
        createWaveformData({ webAudioId });
      }
      return result;
    }
    throw new Error('No waveform data');
  } catch (err) {
    throw new Error(err.message);
  }
}
